const settlementLocations = [

    {
        "name": "Temp",
    },

    {
        "name": "barberSurgeon",
    },
    {
        "name": "blacksmith",
    },
    {
        "name": "boneSmith",
    },
    {
        "name": "catarium",
    },
    {
        "name": "chorusseum",
    },
    {
        "name": "crimsonCrockery",
    },
    {
        "name": "dragonArmory",
    },
    {
        "name": "exaustedLanternHoard",
    },
    {
        "name": "forum",
    },
    {
        "name": "gamingGazebo",
    },
    {
        "name": "glyph",
    },
    {
        "name": "gormery",
    },
    {
        "name": "gormchymist",
    },
    {
        "name": "keeperOfDreams",
    },
    {
        "name": "kingsmith",
    },
    {
        "name": "lanternHoard",
    },
    {
        "name": "leatherWorker",
    },
    {
        "name": "maskMaker",
    },
    {
        "name": "organGrinder",
    },
    {
        "name": "outskirts",
    },
    {
        "name": "plumery",
    },
    {
        "name": "sacredPool",
    },
    {
        "name": "silkMill",
    },
    {
        "name": "skyreefSanctuary",
    },
    {
        "name": "sunThe",
    },
    {
        "name": "throneThe",
    },
    {
        "name": "skinnery",
    },
    {
        "name": "stoneCircle",
    },
    {
        "name": "weaponCrafter",
    },
    {
        "name": "wetResinCrafter",
    },
];


export default settlementLocations;